import { Tooltip } from "react-tooltip";

import { FEATURE_BADGES } from "../data/featureBadges";
import { InfoIcon } from "./icons/InfoIcon";

const TOOLTIP_ID = "feature-badge-tooltip";

export const FeatureBadgesSection = () => (
  <section className="bg-white px-4 py-16 md:px-20 md:py-16 xl:px-0 xl:py-[120px]">
    <div
      className={[
        "mx-auto grid w-full max-w-[336px] grid-cols-2 gap-x-2 gap-y-12",
        "md:max-w-[596px] md:gap-x-12",
        "xl:w-fit xl:max-w-none xl:grid-cols-[210px_164px_164px_210px] xl:gap-x-20 xl:gap-y-0",
      ].join(" ")}
    >
      {FEATURE_BADGES.map((badge) => (
        <div key={badge.id} className="flex flex-col items-center gap-2 text-center">
          <img src={badge.icon} alt="" width={32} height={32} />
          <p className="text-[16px] leading-[1.6] text-[#0D0D0D]">
            <LabelWithInfoIcon label={badge.label} tooltip={badge.tooltip} />
          </p>
        </div>
      ))}
    </div>
    <Tooltip
      id={TOOLTIP_ID}
      place="bottom"
      openEvents={{ mouseenter: true, click: true, focus: true }}
      closeEvents={{ mouseleave: true, blur: true }}
      globalCloseEvents={{ scroll: true, escape: true, clickOutsideAnchor: true }}
      className="!z-10 !max-w-[300px] !rounded-[16px] !bg-white !text-[13px] !leading-[1.6] !tracking-[0.26px] !text-[#0D0D0D] !opacity-100 drop-shadow-[0_2px_6px_rgba(0,0,0,0.12)]"
      classNameArrow="!h-[15px] !w-[15px] !bg-white"
    />
  </section>
);

interface LabelProps {
  label: string;
  tooltip: string;
}

const LabelWithInfoIcon = ({ label, tooltip }: LabelProps) => {
  const trimmed = label.trim();
  const lastSpace = trimmed.lastIndexOf(" ");
  const head = lastSpace === -1 ? "" : trimmed.slice(0, lastSpace);
  const lastWord = lastSpace === -1 ? trimmed : trimmed.slice(lastSpace + 1);

  return (
    <>
      {head && <>{head} </>}
      <span className="whitespace-nowrap">
        {lastWord}
        {"\u00A0"}
        <button
          type="button"
          aria-label="Plus d’informations"
          data-tooltip-id={TOOLTIP_ID}
          data-tooltip-content={tooltip}
          className="inline-flex cursor-pointer items-center align-middle"
        >
          <InfoIcon size={16} />
        </button>
      </span>
    </>
  );
};
